<script>
export default {
  props: {
    image: {
      type: String,
      default: require('@assets/images/reservation/checkout-fail.svg')
    },
    title: {
      type: String,
      default: ''
    },
    imageClass: {
      type: String,
      default: ''
    },
    titleClass: {
      type: String,
      default: ''
    }
  },
}
</script>
<!-- section template -->
<template>
  <div :class="$style.baseError">
    <img
      alt=""
      :src="image"
      class="baseError__img"
      :class="imageClass"
    >
    <div
      v-if="!!title"
      class="baseError__title"
      :class="titleClass"
    >
      {{ title.toUpperCase() }}
    </div>
    <slot/>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.baseError {
  width: 100%;
  padding: 100px 0;
  text-align: center;

  :global {
    .baseError {
      &__img {
        margin: 0 auto 2.5rem;
      }

      &__title {
        color: $color-danger;
        letter-spacing: 0.25em;
      }
    }
  }
}
</style>
